import { useState } from "react";
import { API_BASE } from "../../config/apiConfig";
import { useToast } from "../../hooks/useToast";
import LoadingOverlay from "../../components/loadingOverlay";
import { useNavigate } from "react-router-dom";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { showToast, ToastContainer } = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return showToast("Please enter your email.", "error");

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      await res.json();

      let countdown = 3; // seconds before redirect
      // Initial toast
      showToast(
        `A reset code has been sent to ${email}.\nRedirecting to verification page in ${countdown}s...`,
        "success"
      );

      // create an interval to update the countdown live
      const interval = setInterval(() => {
        countdown--;
        showToast(
          `A reset code has been sent to ${email}.\nRedirecting to verification page in ${countdown}s...`,
          "success",
          "top",
          true,
          3500
        );
        if (countdown <= 0) clearInterval(interval);
      }, 1000);

      // Redirect after timer finishes
      setTimeout(() => {
        clearInterval(interval);
        navigate("/verify-reset", { state: { email } });
      }, 3000);
    } catch {
      showToast("Failed to send reset code.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full flex-grow flex flex-col items-center justify-center py-16">
      <div className="bg-white rounded-xl shadow p-8 w-full max-w-md">
        <h1 className="text-2xl font-semibold text-center mb-6 text-gray-800">
          Forgot Password
        </h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 placeholder:italic placeholder:text-gray-400"
            placeholder="Enter your email"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded disabled:opacity-60"
          >
            {loading ? "Sending..." : "Send Reset Code"}
          </button>
        </form>
      </div>
      <LoadingOverlay show={loading} text="Loading..." />
      <ToastContainer />
    </div>
  );
}
